export default __webpack_public_path__ + "static/media/carouselImage2.71fb9e47.png";